export const DELIVERABLE_CONFIGURATOR_QUERY_KEY = ["deliverable-configurator"];

export const DELIVERABLE_CONFIGURATOR_SYNC_MEDIA_RIGHTS_QUERY_KEY = [
  "deliverable-configurator-sync-media-rights",
];
